module.exports = __webpack_public_path__ + "media/guests/assets/default_apartment-7a91104e0551492db8b1c31e0467084b.jpg";